<template>

 <div>
    <div id="main">
    </div>
  </div>


</template>

<script>
import earch from '@/components/work/until/Echarts.js'
export default {
props:['CorrectList'],
data(){
  return{
     performance:[],
     name:[],
     
  }
},
methods:{

},
mounted(){
if(this.CorrectList){
  for(var i=0;i<this.CorrectList.length;i++){
  this.name.push(this.CorrectList[this.CorrectList.length-i-1].submitDate);  
  this.performance.push(this.CorrectList[i].performance)
  }
  
}

    console.log(this.CorrectList)
var myChart = earch.init(document.getElementById('main'));
myChart.setOption({

 xAxis: {
    type: 'category',
    data: this.name
  },
  yAxis: {
    type: 'value'
  },
  series: [
    {
      data: this.performance,
      type: 'line'
    }
  ]
});

}
}

</script>

<style scoped>

  
h2{
    text-align: center;
    padding: 30px;
    font-size: 18px;
  }
  #main{
    width: 80%;
    height: 500px;
    border: 1px solid red;
    margin: 0 auto;
  }

#span1{
  padding-left: 20px;
}

</style>


// WEBPACK FOOTER //
// src/components/work/student/ViewScoreEcharts.vue